import React from "react";
import EducationForm from "./EducationForm";
import EducationTable from "./EducationTable";
import "./EducationStep.css";
import ApplicationHeader from "../ApplicationHeader";

const EducationStep = (props) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <p style={{ margin: 0 }}>
          Include your educational background, such as degrees earned, certifications, or relevant coursework.
        </p>
        <EducationForm
          createEducation={props.createEducation}
          application={props.application}
          educationEntries={props.educationEntries}
          handleDeleteEducation={props.handleDeleteEducation}
          updateEducation={props.updateEducation}
        />
      </div>

      <EducationTable
        educationEntries={props.educationEntries}
      />
    </div>
  );
};

export default EducationStep;
